// import React, { useState, useNavigate } from 'react';
import { Link } from 'react-router-dom';
import styles from './style.module.css';

// import {
//   allSites,
// } from '../../../configs';

export default function ScrollMenu(props) {
  // const navigate = useNavigate();
  const {
    // mandatory props
    data,
  } = props;

  const handleCLick = () => {
    // navigate('#');
  };

  return (
    <div className={styles.vertical_menu}>
      <h3 className={styles.title}>Site</h3>
      {data.map((item) => (
        <Link
          // onClick={handleCLick}
          to={'/detail-facility'}
          key={`site-navigation-${item.site_id}`}
          title={item.site_name}
        >
          {item.site_name}
        </Link>
      ))}
    </div>
  );
}
